module.exports = __webpack_public_path__ + "img/reportageTVASports.50c09c4e.png";